import { formatInr } from '../../utils/bookingUtils';

const SummaryCard = ({
  stay,
  lineItems = [],
  total,
  currency,
  primaryLabel,
  onPrimary,
  primaryDisabled,
  secondaryLabel,
  onSecondary,
  footerNote,
}) => {
  const image =
    stay?.coverImage ||
    stay?.featured_image ||
    stay?.image_url ||
    'https://images.unsplash.com/photo-1505691938895-1758d7feb511?auto=format&fit=crop&w=240&q=80';

  return (
    <div className="rounded-2xl border border-[#E7DED4] bg-white p-5 shadow-[0_18px_40px_rgba(15,23,42,0.1)]">
      <div className="text-sm uppercase tracking-[0.22em] text-slate-500">Stay summary</div>
      {stay && (
        <div className="mt-3 flex items-center gap-3">
          <img src={image} alt={stay.title || stay.name || 'Stay'} className="h-14 w-14 rounded-xl object-cover" />
          <div>
            <div className="text-sm font-semibold text-slate-900">{stay.title || stay.name || 'Homevilas stay'}</div>
            <div className="text-xs text-slate-500">{[stay.city, stay.area].filter(Boolean).join(', ')}</div>
          </div>
        </div>
      )}
      <div className="mt-4 space-y-2 text-sm text-slate-700">
        {lineItems.map((row) => (
          <div key={row.label} className="flex justify-between gap-2">
            <span>{row.label}</span>
            <span className="font-medium">{formatInr(row.value, currency)}</span>
          </div>
        ))}
        <div className="flex justify-between border-t pt-3 text-base font-semibold text-slate-900">
          <span>Total payable</span>
          <span>{formatInr(total, currency)}</span>
        </div>
      </div>
      <div className="mt-4 flex flex-col gap-2">
        {primaryLabel && (
          <button
            type="button"
            onClick={onPrimary}
            disabled={primaryDisabled}
            className="rounded-xl bg-[#1F2A37] px-4 py-3 text-sm font-semibold text-white shadow-sm hover:bg-[#111827] disabled:opacity-60"
          >
            {primaryLabel}
          </button>
        )}
        {secondaryLabel && (
          <button
            type="button"
            onClick={onSecondary}
            className="rounded-xl border border-slate-200 px-4 py-2 text-sm font-semibold text-slate-700 hover:border-slate-300"
          >
            {secondaryLabel}
          </button>
        )}
        {footerNote && <div className="text-xs text-slate-500">{footerNote}</div>}
      </div>
    </div>
  );
};

export default SummaryCard;
